import React, { lazy } from 'react';
import transportStatuses from '../eNums/transportStatuses.enum';
import Loadable from '../common/Loadable';

// project layouts

import ProtectAdminRoute from '../permissions/ProtectAdminRoute';

// render - pages
import Landing from '../pages/Landing';
import P404 from '../pages/P404';
import Dark from '../layout/admin/public/Dark';

const Transport = Loadable(
  lazy(() => import('../pages/report/transport/index')),
);
const OnTheWay = Loadable(
  lazy(() => import('../pages/report/transport/OnTheWay')),
);
const InParking = Loadable(
  lazy(() => import('../pages/report/transport/InParking')),
);
const WeighbridgeLoading = Loadable(
  lazy(() => import('../pages/report/weighbridge/Loading')),
);
const WeighbridgeDicharge = Loadable(
  lazy(() => import('../pages/report/weighbridge/Discharge')),
);
const WeighbridgeDicharge2 = Loadable(
  lazy(() => import('../pages/report/weighbridge/Discharge2')),
);
const DischargeOnTheWay = Loadable(
  lazy(() => import('../pages/report/transport/DischargeOnTheWay')),
);
const ByStatus = Loadable(
  lazy(() => import('../pages/report/transport/ByStatus')),
);
const DischargeWaiting = Loadable(
  lazy(() => import('../pages/report/transport/DischargeWaiting')),
);
const LoadingOnTheWay = Loadable(
  lazy(() => import('../pages/report/transport/LoadingOnTheWay')),
);
const LoadingWaiting = Loadable(
  lazy(() => import('../pages/report/transport/LoadingWaiting')),
);
const Waiting = Loadable(
  lazy(() => import('../pages/report/transport/Waiting')),
);
const FilterLoadings = Loadable(
  lazy(() => import('../pages/report/transport/FilterLoadings')),
);
const LoadingPolompPending = Loadable(
  lazy(() => import('../pages/report/transport/LoadingPolompPending')),
);
const Combined = Loadable(
  lazy(() => import('../pages/report/transport/Combined')),
);
const Final = Loadable(lazy(() => import('../pages/report/weighbridge/Final')));
const Lab = Loadable(lazy(() => import('../pages/report/weighbridge/Lab')));
const Shift = Loadable(lazy(() => import('../pages/report/weighbridge/Shift')));
const Car = Loadable(lazy(() => import('../pages/admin/car')));
const Setting = Loadable(lazy(() => import('../pages/admin/setting')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  // element: <ProtectAdminRoute />,
  children: [
    {
      path: '',
      element: <ProtectAdminRoute />,
      children: [
        {
          path: '',
          element: <Landing />,
        },
        {
          path: '/security',
          element: <Landing />,
        },
        {
          path: '/transport',
          element: <Transport />,
        },
        {
          path: '/transport/onTheWay',
          element: <OnTheWay />,
        },
        {
          path: '/transport/inParking',
          element: <InParking />,
        },
        {
          path: '/weighbridge/loading',
          element: <WeighbridgeLoading />,
        },
        {
          path: '/weighbridge/discharge',
          element: <WeighbridgeDicharge />,
        },
        {
          path: '/transport/discharge/ontheway',
          element: <DischargeOnTheWay />,
        },
        {
          path: '/transport/filter/status/:status',
          element: <ByStatus />,
        },
        {
          path: '/transport/discharge/waiting',
          element: <DischargeWaiting />,
        },
        {
          path: '/transport/loading/ontheway',
          element: <LoadingOnTheWay />,
        },
        {
          path: '/transport/loading/waiting',
          element: <LoadingWaiting />,
        },
        {
          path: '/transport/loading/polomp',
          element: <LoadingPolompPending />,
        },
        {
          path: '/transport/waiting',
          element: <Waiting />,
        },
        {
          path: '/weighbridge/filterloadings/:dest',
          element: <FilterLoadings />,
        },
        {
          path: '/admin/car',
          element: <Car />,
        },
        {
          path: '/admin/setting',
          element: <Setting />,
        },
      ],
    },
    {
      path: '/frame',
      element: <Dark />,
      children: [
        {
          path: 'weighbridge/discharge',
          element: <WeighbridgeDicharge frame={true} />,
        },
        {
          path: 'weighbridge/discharge2',
          element: <WeighbridgeDicharge2 frame={true} />,
        },
        {
          path: 'weighbridge/loading',
          element: <WeighbridgeLoading frame={true} />,
        },
        {
          path: 'transport/onTheWay',
          element: <OnTheWay frame={true} />,
        },
        {
          path: 'transport/inParking',
          element: <InParking frame={true} />,
        },
        {
          path: 'transport',
          element: <Transport frame={true} />,
        },
        {
          path: 'transport/discharge/ontheway',
          element: <DischargeOnTheWay frame={true} />,
        },
        {
          path: 'transport/filter/status/:status',
          element: <ByStatus frame={true} />,
        },
        {
          path: 'transport/discharge/waiting',
          element: <DischargeWaiting frame={true} />,
        },
        {
          path: 'transport/loading/ontheway',
          element: <LoadingOnTheWay frame={true} />,
        },
        {
          path: 'transport/loading/waiting',
          element: <LoadingWaiting frame={true} />,
        },
        {
          path: 'transport/loading/polomp',
          element: <LoadingPolompPending frame={true} />,
        },
        {
          path: 'transport/waiting',
          element: <Waiting frame={true} />,
        },
        {
          path: 'weighbridge/filterloadings/:dest',
          element: <FilterLoadings frame={true} />,
        },
        {
          path: 'weighbridge/combined',
          element: <Combined frame={true} />,
        },
        {
          path: 'weighbridge/final',
          element: <Final frame={true} />,
        },
        {
          path: 'weighbridge/lab',
          element: <Lab frame={true} />,
        },
        {
          path: 'weighbridge/shift',
          element: <Shift frame={true} />,
        },
        {
          path: 'admin/car',
          element: <Car frame={true} />,
        },
        {
          path: 'admin/setting',
          element: <Setting frame={true} />,
        },
      ],
    },

    {
      path: '*',
      element: <P404 />,
    },
  ],
};

export default MainRoutes;
